import { Trans, t } from '@lingui/macro'
import IconPencil from '../../../components/common/icon/IconPencil'
import IconTrash from '../../../components/common/icon/IconTrash'
import React, { useContext } from 'react'
import { ManageCampaignContext } from '../ManageCampaignPage'
import { isCampaignImmediate } from '../utils'
import IconEye from '../../../components/common/icon/IconEye'
import { useFeatureFlags } from '../../../app/hooks/useFeatureFlags'
import { notificationEmailName } from '../../../../../shared/emails'
import { useDefaultOrgEmailIdentityQuery } from '../../../app/hooks/useDefaultOrgEmailIdentity.codegen'
import { ButtonIcon } from 'front-end/src/components'
import IconDuplicate from 'front-end/src/components/common/icon/IconDuplicate'

interface IProps {
  onEditClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onDeleteClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onCopyClick: (e: React.MouseEvent<HTMLSpanElement>) => void
}

export const CampaignActionControls = ({
  onEditClick,
  onDeleteClick,
  onCopyClick
}: IProps) => {
  const { campaign } = useContext(ManageCampaignContext)
  if (!campaign) {
    return null
  }

  let editButton = (
    <ButtonIcon
      circular
      icon={<IconPencil />}
      aria-label={t`Edit`}
      hint={t`Edit`}
      onClick={onEditClick}
      className="IconButton"
    />
  )
  let showDeleteButton = true
  if (
    campaign.wasCampaignDeactivated ||
    (campaign.is_active && isCampaignImmediate(campaign))
  ) {
    editButton = (
      <ButtonIcon
        circular
        icon={<IconEye />}
        aria-label={t`Details`}
        hint={t`Details`}
        onClick={onEditClick}
        className="IconButton"
      />
    )
    showDeleteButton = false
  }

  return (
    <div className="CampaignAction__controls">
      <div className="controls-inner">
        {editButton}
        <ButtonIcon
          circular
          icon={<IconDuplicate />}
          aria-label={t`Copy`}
          hint={t`Copy`}
          onClick={onCopyClick}
          className="IconButton"
        />
        {showDeleteButton ? (
          <ButtonIcon
            circular
            icon={<IconTrash />}
            aria-label={t`Delete`}
            hint={t`Delete`}
            onClick={onDeleteClick}
            className="IconButton"
          />
        ) : null}
      </div>
    </div>
  )
}

function useDefaultOrgEmailIdentity() {
  const { data, refetch, loading } = useDefaultOrgEmailIdentityQuery({
    fetchPolicy: 'cache-first'
  })

  return {
    loadingDefaultOrgEmailIdentity: loading,
    defaultOrgEmailIdentity:
      data?.admin?.organisation?.defaultOrganisationEmailIdentity,
    refetchDefaultOrgEmailIdentity: refetch
  }
}

export const CampaignActionEmailSender = ({
  senderName
}: {
  senderName: string | null
}) => {
  const { featureFlags } = useFeatureFlags()
  const { defaultOrgEmailIdentity } = useDefaultOrgEmailIdentity()

  if (!featureFlags?.multiple_senders) {
    return null
  }

  if (!senderName) {
    return (
      <span>
        <b>
          <Trans>Sender</Trans>:{' '}
        </b>{' '}
        <i>{defaultOrgEmailIdentity?.name || notificationEmailName}</i>
      </span>
    )
  }

  return (
    <span>
      <b>
        <Trans>Sender</Trans>:{' '}
      </b>{' '}
      <i>{senderName}</i>
    </span>
  )
}
